import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ComplianceRecordsQuery } from "../graphql/queries";
import type {
  ComplianceRecordsQueryType,
  ComplianceRecordsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useComplianceRecordsQuery = (
  options?: QueryHookOptions<
    ComplianceRecordsQueryType,
    ComplianceRecordsQueryVariablesType
  >
) => {
  return useQuery<
    ComplianceRecordsQueryType,
    ComplianceRecordsQueryVariablesType
  >(ComplianceRecordsQuery, options);
};
